export const formReducer = (state, { field, value }) => {
  return {
    ...state,
    [field]: value,
  };
};

export const loginFormReducer = (state, action) => {
  switch (action.type) {
    case "username":
      return { ...state, username: action.payload.value };
    case "password":
      return { ...state, password: action.payload.value };
    case "validation":
      return { ...state, errors: action.payload.issues };
    case "showPassword":
      return { ...state, showPassword: action.payload.value };
    default:
      return action.payload; // Replace State in case that is needed
  }
};

export const forgotFormReducer = (state, action) => {
  switch (action.type) {
    case "email":
      return { ...state, email: action.payload };
    case "validation":
      return { ...state, errors: action.payload };
    default:
      return action.payload; // Replace State in case that is needed
  }
};

export const resetPasswordFormReducer = (state, action) => {
  switch (action.type) {
    case "password":
      return { ...state, password: action.payload };
    case "validation":
      return { ...state, errors: action.payload };
    case "confirmPassword":
      return { ...state, confirmPassword: action.payload };
    case "showCPassword":
      return { ...state, showCPassword: action.payload };
    case "showPassword":
      return { ...state, showPassword: action.payload };
    default:
      return action.payload; // Replace State in case that is needed
  }
};

export const updateProfileFormReducer = (state, action) => {
  switch (action.type) {
    case "firstname":
      return { ...state, firstname: action.payload.value };
    case "lastname":
      return { ...state, lastname: action.payload.value };
    case "password":
      return { ...state, password: action.payload.value };
    case "validation":
      return { ...state, errors: action.payload };
    case "confirmPasswrd":
      return { ...state, confirmPasswrd: action.payload.value };
    case "phone":
      return { ...state, phone: action.payload.value };
    case "showPassword":
      return { ...state, showPassword: action.payload.value };
    case "showCPassword":
      return { ...state, showCPassword: action.payload.value };
    case "title":
      return { ...state, title: action.payload.value };
    case "photoUpload":
      return { ...state, photoUpload: action.payload.value };
    case "setInitialData":
      return {
        firstname: action.payload.data.first_name,
        lastname: action.payload.data.last_name,
        email: action.payload.data.email,
        username: action.payload.data.username,
        phone: action.payload.data.userprofile.phone_number,
        title: action.payload.data.userprofile.title,
        photoUpload: action.payload.data.userprofile.profile_pic,
        user: action.payload.data.id,
      };
    default:
      return action.payload.data; // Replace State in case that is needed
  }
};

export const InviteOrganizationFormReducer = (state, action) => {
  switch (action.type) {
    case "email":
      return { ...state, email: action.payload.value };
    case "companyName":
      return { ...state, companyName: action.payload.value };
    case "validation":
      return { ...state, errors: action.payload };
    case "address":
      return { ...state, address: action.payload.value };
    case "sub_domain":
      return { ...state, sub_domain: action.payload.value };
    case "additionaldetails":
      return { ...state, additionaldetails: action.payload.value };
    case "organization_type":
      return { ...state, organization_type: action.payload.value };
    case "organizationImage":
      return { ...state, organizationImage: action.payload.fileUploaded };
    default:
      return action.payload; // Replace State in case that is needed
  }
};

export const AddUserFormReducer = (state, action) => {
  switch (action.type) {
    case "email":
      return {
        ...state,
        email: action.payload.value,
        username: action.payload.value,
      };
    case "first_name":
      return { ...state, first_name: action.payload.value };
    case "last_name":
      return { ...state, last_name: action.payload.value };
    case "validation":
      return { ...state, errors: action.payload };
    case "userImage":
      return { ...state, userImage: action.payload.userImage };
    default:
      return action.payload; // Replace State in case that is needed
  }
};
